import type { InputHTMLAttributes } from "react";
import styles from "./styles.module.css";

export const SearchPanel = (props: InputHTMLAttributes<HTMLInputElement>) => {
  return (
    <input
      placeholder={"Поиск объектов"}
      className={styles["search-input"]}
      {...props}
    />
  );
};
